export default "/images/vendor/flag-icon-css/flags/1x1/nr.svg?1f7cfffb6cb01e5215ada60e128ea252";